import { useMemo } from "react";

import { Skeleton } from "antd";

import { JourneyVersion } from "Types/Journey";

import { JourneyVersionItem } from "../JourneyVersionItem/JourneyVersionItem";

import styles from "./JourneyVersionsList.module.scss";

type JourneyVersionsListProps = {
    versionList: JourneyVersion[];
    loading: boolean;
    currentVersion: string;
    journeyId: string;
    onClose: () => void;
};

export function JourneyVersionsList({
    versionList,
    loading,
    currentVersion,
    journeyId,
    onClose,
}: JourneyVersionsListProps): JSX.Element {
    const renderSkeleton = useMemo(() => {
        return Array.from({ length: 3 }).map((_, index) => <Skeleton active paragraph={{ rows: 1 }} key={index} />);
    }, []);

    if (loading) {
        return <div className={styles.skeletonContainer}>{renderSkeleton}</div>;
    }

    return (
        <div data-testid="journey-versions-container">
            {versionList.map((version) => (
                <JourneyVersionItem
                    key={`${version.id}-${version.version}`}
                    journeyVersionData={version}
                    journeyId={journeyId}
                    currentVersion={currentVersion}
                    onClose={onClose}
                />
            ))}
        </div>
    );
}
